export const setSite = (store, site) => {
    const s = site;
    store.setState({ site: s });
  };

  export const setSpace = (store, space) => {
    const s = space;
    store.setState({ space: s });
  };

  export const setBuilding = (store, building) => {
    const b = building;
    store.setState({ building: b });
  };

  export const setZone = (store, zone) => {
    const z = zone;
    store.setState({ zone: z });
  };


  export const setUser = (store, user) => {
    const u = user;
    store.setState({ user: u });
  };

  export const setEquipment = (store, equipment) => {
    const e = equipment;
    store.setState({ equipment: e });
  };

  export const setFeature = (store, feature) => {
    const f = feature;
    store.setState({ feature: f });
  };

  export const setCurrentModule = (store, module) => {
    const m = module;
    store.setState({ currentModule: m });
  };

  export const setContext = (store, context) => {
    store.setState({ context: context} )
  } 